import React, {useEffect, useState, useRef} from "react";
import "./HomePageStyles.css";
import useSendOtp from "../../hooks/useSendOtp";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {v4 as uuid} from "uuid";
import {
    resourceKey,
    regex,
    CONST_CONF,
    CONST_LABELS,
    regGtagOtpValidate,
    regGtagOtpWithJson,
    regConversion,
} from "../Commons";

import axios from "axios";
import {ResponseModel} from "../../models/ResponseModel";
import {AntiFraudFetchModel} from "../../models/AntifraudFetchModel";
import {SubRequestFetchModel} from "../../models/SubRequestFetchModel";
import {SubConfirmFetchModel} from "../../models/SubConfirmFetchModel";
import * as process from "process";
//import String(CONST_CONF.get('HOME_CSS'));

const HomePage: React.FC = () => {
    let [phoneNumber, setPhoneNumber] = useState<string>("");
    const purePhoneNumber: any = useRef(null);
    // const [productId, setProductId] = useState<any>(Number(CONST_LABELS.get("PRODUCT_ID_1")));

    const [providerName, setProviderName] = useState<string>(String(process.env.REACT_APP_PROVIDER_NAME))
    const [providerType, setProviderType] = useState<string>(String(process.env.REACT_APP_PROVIDER_TYPE));

    const [showPin, setShowPin] = useState<boolean>(false);
    const [pinEntered, setPinEntered] = useState<string>("");
    // const [pinUniqueId, setPinUniqueId] = useState<string>("");

    const [showError, setShowError] = useState<string>("");
    const [buttonError, setButtonError] = useState<boolean>(false);
    const [videoClicked, setVideoClicked] = useState<boolean>(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const unique_id = uuid();
    const [evinaScriptRes, setEvinaScriptRes] = useState<any>({});
    const [showCongrtas, setShowCongrats] = useState<boolean>(false);

    const navigate = useNavigate();
    const location = useLocation()
    const congrImg = require("../../assets/images/congrats.png");
    const bannerImg = require("../../assets/images/MyToonsLogo.png");
    const watchNow = require("../../assets/images/Toonz-Gummy-bear-WATCH-NOW.png");
    const playerImg = require("../../assets/images/Batelco-MyToonz.png");
    const playerWideImg = require("../../assets/images/Batelco-MyToonz.png");
    const playButton = require("../../assets/images/play-button.png");
    const gummyBearBackdrop = require("../../assets/images/Gummy-bear-fake-episode-dark.jpg");
    const batelcoLogo = require("../../assets/images/Batelco-colored.png")
    // const batelcoSlogan = require("../../assets/images/Batelco Tagline.webp")
    // const otpBannerImg = require("../../assets/images/banner-1.jpg");
    const {loading, sendOtpHandler, checkOtpHandler} = useSendOtp();
    const campaignIdFromParam = searchParams.get("campaignId");
    const clickId = searchParams.get("clickid")
    const campaignIdFromEnv: string | undefined = process.env.REACT_APP_CAMPAIGN_ID

    const subReqId: any = useRef(null);
    const reqId: any = useRef(uuid())
    const tokenStr: string = window.btoa(`${process.env.REACT_APP_AFF_USER}:${process.env.REACT_APP_AFF_PWD}`)


    var event = new Event("DCBProtectRun");
    document.dispatchEvent(event);
    //subconfirm Request start
    const onPinSubmitHandler = () => {
        if (pinEntered.length !== 0) {

            const subConfirmUrl: string = "/provider/api/subConfirm"
            // const subConfirmUrl: string = "http://localhost:3000/subConfirmSuccess"

            const headers = {
                "Content-Type": "application/json",
                Authorization: "Basic " + tokenStr,
                correlatorId: reqId.current,
                ResourceKey: resourceKey.subConfirm,
            };

            const config = {
                url: subConfirmUrl,
                method: "POST",
                // method: "GET",
                headers: headers,
                data: {
                    source: "MPLP",
                    packName: "TOONZ_DAILY",
                    planName: "DAILY",
                    providerName: providerName,
                    providerType: providerType,
                    userId: purePhoneNumber.current,
                    otp: pinEntered,
                    countryCode: "BHR",
                    campaignId: campaignIdFromEnv,
                    extendedParameters: {clickId: clickId}
                },
            };
            axios
                .request<SubConfirmFetchModel>(config)
                .then(function (response) {
                    const subConfirmResponse = response.data;

                    // if (CONST_CONF.get("IS_TEST_ENV") == "1") {
                    //   subConfirmResponse.code = "SUCCESS"; //Test
                    //   // if (pinEntered === "7860") {
                    //   //   subConfirmResponse.code = 1; //If PIN Entered is 7860 then consider success else done'
                    //   // }
                    //   // else jsonRes.resCode = 0; //test eanbled but if you enter 7860 then only pin sucess else dont;
                    // }

                    //alert("resCode: "+jsonRes.resCode+", desc: "+jsonRes.resDesc+", test: "+CONST_CONF.get("IS_TEST_ENV"))
                    //if (jsonRes.resCode === 1 && '7860'==pinEntered) {// Only for testing comment in prod

                    console.log("pin is sent, handling success")

                    if (subConfirmResponse.code === "SUCCESS") {
                        regGtagOtpValidate("Success", subConfirmResponse, campaignIdFromParam);
                        regConversion();
                        if (subConfirmResponse.redirectURL !== null) {
                            // console.log('CGURL FOUND, it is', subConfirmResponse.redirectURL)
                            navigate("./success", {replace: false, state: {id: subConfirmResponse.redirectURL}});
                        } else navigate("./success", {replace: false});

                        // setShowCongrats(true);
                    }
                    // if ("1" == CONST_CONF.get("PRINT_LOG")) console.log(jsonRes);
                })
                .catch(function (error) {
                    let subConfirmError = error.response.data

                    console.log("pin is sent, handling fail")
                    // if (subConfirmError.code === "SUBSCRIPTION_ALREADY_EXIST") { //TODO: Add GTM flags for sub already exist if needed
                    //   if (subConfirmError.redirectURL !== null) {
                    //     console.log('CGURL FOUND, it is', subConfirmError.redirectURL)
                    //     navigate("./success", { replace: false, state: {id: subConfirmError.redirectURL}} );
                    //   }
                    // }

                    if (subConfirmError === null) {
                        setShowError(
                            "Unable to Process Request , Kindly Contact System support."
                        );
                        regGtagOtpValidate(
                            "Fail-Unable to Process Request",
                            subConfirmError, campaignIdFromParam
                        );
                        <div className="error-message">{showError}</div>;
                        return false;
                    } else {
                        regGtagOtpValidate(
                            "Fail-" + subConfirmError.code, subConfirmError, campaignIdFromParam
                        );

                        if (subConfirmError.code === "GEN_ERR") {
                            setShowError
                            ("Invalid request / expired , Please refresh and resend request.");
                            <div className="error-message">{showError}</div>;
                            //console.log("------");
                        }

                        if (subConfirmError.code === "INVALID_MSISDN") {
                            setShowError("Please enter a valid Mobile Number.");
                            <div className="error-message">{showError}</div>;
                        }

                        if (subConfirmError.code === "OTP_NOT_VALID") {
                            setShowError(String(CONST_LABELS.get("LBL_ERR_PIN_WRONG")));
                            <div className="error-message">{showError}</div>;
                        }
                        if (subConfirmError.code === "OTP_NOT_VALID") {
                            setShowError("Wrong OTP entered.");
                            <div className="error-message">{showError}</div>;
                        }

                        if (subConfirmError.code === "SUBSCRIPTION_ALREADY_EXIST") {
                            // if ("1" == CONST_CONF.get("PRINT_LOG"))
                            //   console.log("we should be redirecting here");

                            if (typeof subConfirmError.redirectURL != "undefined") {
                                // window.location.replace(String(jsonRes.cgURL)) // OTP Page redirect, in case of antifraud
                                // if ("1" == CONST_CONF.get("PRINT_LOG"))
                                //   console.log("REDIRECTING TO SOMETHING");
                                navigate("./success", {
                                    replace: false,
                                    state: {id: subConfirmError.redirectUrl},
                                });
                            }
                            navigate("./success", {replace: true}); //TODO redirect page
                        }

                        //MySwal.fire(<p>{jsonRes.errordesc}</p>);
                    }

                });

            /*checkOtpHandler(providerName, providerType, pinEntered, purePhoneNumber.current, reqId, resourceKey.subConfirm)
            .then(

              (res) => {
              //   if (!res.isJson()) {
              //     setShowError("Please try again")
              //     return false
              //   }
                //const obj = JSON.parse(res.substring(1, res.length - 1)
                // if ("1" == CONST_CONF.get("PRINT_LOG")) console.log("reqId current inside subconfirm is", pinUniqueId)

                const jsonRes = res;

                // MySwal.fire(<p>{jsonRes.errordesc}</p>);
                if (CONST_CONF.get("IS_TEST_ENV") == "1") {
                  jsonRes.code = "SUCCESS"; //Test
                  if (pinEntered === "7860") {
                    jsonRes.resCode = 1; //If PIN Entered is 7860 then consider success else done'
                  }
                  else jsonRes.resCode = 0; //test eanbled but if you enter 7860 then only pin sucess else dont;
                }
                if (jsonRes === null) {
                  setShowError(
                    "Unable to Process Request , Kindly Contact System support."
                  );
                  regGtagOtpValidate(
                    "Fail-Unable to Process Request",
                    jsonRes, campaignIdFromParam
                  );
                  <div className="error-message">{showError}</div>;
                  return false;
                }

                //alert("resCode: "+jsonRes.resCode+", desc: "+jsonRes.resDesc+", test: "+CONST_CONF.get("IS_TEST_ENV"))
                //if (jsonRes.resCode === 1 && '7860'==pinEntered) {// Only for testing comment in prod
                if (jsonRes.code === "SUBSCRIPTION_ALREADY_EXIST") { //TODO: Add GTM flags for sub already exist if needed
                  if (jsonRes.redirectUrl !== null) {
                    console.log('CGURL FOUND, it is', jsonRes.redirectUrl)
                    navigate("./success", { replace: false, state: {id: jsonRes.redirectUrl}} );
                  }
                }


                if (jsonRes.code === "SUCCESS") {
                  regGtagOtpValidate("Success", jsonRes, campaignIdFromParam);
                  regConversion();
                  if (jsonRes.redirectUrl !== null) {
                    console.log('CGURL FOUND, it is', jsonRes.redirectUrl)
                    navigate("./success", { replace: false, state: {id: jsonRes.redirectUrl}} );
                  } else navigate("./success", { replace: false} );

                  // setShowCongrats(true);
                } else {
                  regGtagOtpValidate(
                    "Fail-" + jsonRes.code, jsonRes, campaignIdFromParam
                  );
                  var errMsg: string = "";
                  if (jsonRes.code === "GEN_ERR") {
                    errMsg =
                      "Invalid request / expired , Please refresh and resend request.";
                    //console.log("------");
                  } else if (jsonRes.code === "INVALID_MSISDN") {
                    errMsg = "Please enter a valid Mobile Number.";
                  } else if (jsonRes.code === "OTP_NOT_VALID") {
                    console.log('we are in the wrong pin check?')

                    errMsg = "Wrong OTP entered.";
                  } else {
                    errMsg = String(CONST_LABELS.get("LBL_ERR_PIN_WRONG"));
                  }
                  setShowError(errMsg);
                  <div className="error-message">{showError}</div>;
                  //MySwal.fire(<p>{jsonRes.errordesc}</p>);
                }
                if ("1" == CONST_CONF.get("PRINT_LOG")) console.log(jsonRes);
              }
            );
          } else {
            setShowError(String(CONST_LABELS.get("LBL_ERR_PIN_EMPTY")));
            <div className="error-message">{showError}</div>;
          }*/
        }
        ;
    }
    //subconfirm Request end


    //sub Request start
    const onSubmitHandler = () => {
        regGtagOtpWithJson(
            "OTPReqBtnClicked",
            {action: "submit button clicked "},
            campaignIdFromParam
        );
        // if (productId < 0) {
        //   setShowError("Please choose an Service Provider")
        //   return false
        // }

        if ("1" == CONST_CONF.get("PRINT_LOG"))
            console.log(phoneNumber, phoneNumber.substring(0, 5), phoneNumber);


        if (phoneNumber.substring(0, 1) === "0") {
            phoneNumber = phoneNumber.slice(1, 10);
            if ("1" == CONST_CONF.get("PRINT_LOG"))
                console.log("phoneNumber with 0 removed is ", phoneNumber);
        }

        purePhoneNumber.current =
            String(CONST_LABELS.get("COUNTRY_CODE")) + phoneNumber;
        if ("1" == CONST_CONF.get("PRINT_LOG")) {
            console.log("phoneNumber is", phoneNumber);
            console.log("Appended purePhoneNumber is", purePhoneNumber.current);
        }

        if (
            purePhoneNumber.current.length !==
            Number(CONST_LABELS.get("PHONE_LENGTH"))
        ) {
            if ("1" == CONST_CONF.get("PRINT_LOG"))
                console.log(
                    "purePhonenumber is not equal to correct phone length",
                    purePhoneNumber.current,
                    Number(CONST_LABELS.get("PHONE_LENGTH"))
                );
            setShowError(String(CONST_LABELS.get("LBL_ENTERED_WRONG_NUMBER")));
            return false;
        }
        // if (purePhoneNumber.current.substring(0, 3) != Number(CONST_LABELS.get("COUNTRY_CODE"))) {
        //     console.log("purePhoneNumber does not start with correct country code 971",  Number(CONST_LABELS.get("COUNTRY_CODE")));
        //     setShowError(String(CONST_LABELS.get("LBL_ENTERED_WRONG_COUNTRYCODE")));
        //     return false;
        // };

        if (purePhoneNumber.current.substring(0, 1) === "0") {
            purePhoneNumber.current.replaceAt(
                0,
                String(CONST_LABELS.get("COUNTRY_CODE"))
            );
            if ("1" == CONST_CONF.get("PRINT_LOG"))
                console.log("Replaced 0 at beginning with 968");
        }
        if ("1" == CONST_CONF.get("PRINT_LOG"))
            console.log("Right before sendOtpHandler");

        if (!regex.test(purePhoneNumber.current)) {
            // if ("1" == CONST_CONF.get("PRINT_LOG")) {
                console.log("Regex test is", regex.test(phoneNumber));
                console.log(
                    `DOES NOT MATCH, max number length is`,
                    Number(CONST_LABELS.get("PHONE_LENGTH")), purePhoneNumber.current.length
                );
                console.log("purephonenumber is ", purePhoneNumber.current)
            // }
            regGtagOtpWithJson(
                "Fail-InvalidPhone",
                {action: "submit button clicked"},
                campaignIdFromParam
            );
            setShowError("Phone number is invalid. Please enter a valid number");
            return false;
        } else {
            // if ("1" == CONST_CONF.get("PRINT_LOG")) {
                console.log("MATCHED REGEX PATTERN");
                console.log("Regex test is", regex.test(purePhoneNumber.current));
            // }
        }

        const subRequestUrl: string = "/provider/api/subRequest";
        // const subRequestUrl: string = "http://localhost:3000/subRequestFailGenErr";

        const headers = {
            "Content-Type": "application/json",
            Authorization: "Basic " + tokenStr,
            correlatorId: reqId.current,
            ResourceKey: resourceKey.subRequest,
        };
        const config = {
            url: subRequestUrl,
            method: "POST",
            // method: "GET",
            headers: headers,
            data: {
                source: "MPLP",
                packName: "TOONZ_DAILY",
                planName: "DAILY",
                countryCode: "BHR",
                providerName: providerName,
                providerType: providerType,
                userId: purePhoneNumber.current,
                campaignId: campaignIdFromEnv,
                extendedParameters: {clickId: clickId}
            },
        };
        console.log(config)
        axios
            .request<SubRequestFetchModel>(config)
            .then(function (response) {
                let subRequestResponse = response.data;

                regGtagOtpWithJson(
                    process.env.REACT_APP_GTAG_SUBREQ_BUTTON_FLAG ?? 'missing from .env',
                    subRequestResponse,
                    campaignIdFromParam
                );

                if (subRequestResponse.code === "SUCCESS") {
                    regGtagOtpWithJson(
                        process.env.REACT_APP_GTAG_SUBREQ_SUCCESS_FLAG ?? 'missing from .env file',
                        subRequestResponse,
                        campaignIdFromParam
                    );

                    // setProviderName(subRequestResponse.providerName!);
                    // setProviderType(subRequestResponse.providerType!);

                    if (typeof subRequestResponse.redirectURL != "undefined") window.location.replace(String(subRequestResponse.redirectURL))

                    if (subRequestResponse.nextActions.includes("SUB-CONFIRM")) setShowPin(true);

                }
            })
            .catch(function (error) {
                let subRequestError = error.response.data;

                // console.log("This is raw error", error);
                // console.log("This is in var", subRequestError);

                if (subRequestError === null) {
                    regGtagOtpWithJson(
                        "Fail-Generic Error",
                        subRequestError,
                        campaignIdFromParam
                    );
                    setShowError("Unable to process request, contact support");
                    <div className="error-message">{showError}</div>;

                    return false;
                }

                if (subRequestError.code === "OTP_LIMIT_REACHED") {
                    setShowError(
                        "You have reached the OTP Limit. Please try again in 24 hours"
                    );
                    <div className="error-message"> {showError} </div>;
                    return false;
                }

                if (subRequestError.code === "SUBSCRIPTION_ALREADY_EXIST") {
                    // if ("1" == CONST_CONF.get("PRINT_LOG"))
                    //   console.log("we should be redirecting here");

                    if (typeof subRequestError.redirectURL != "undefined") {
                        // window.location.replace(String(jsonRes.cgURL)) // OTP Page redirect, in case of antifraud
                        // if ("1" == CONST_CONF.get("PRINT_LOG"))
                        //   console.log("REDIRECTING TO SOMETHING");
                        navigate("./success", {
                            replace: false,
                            state: {id: subRequestError.redirectUrl},
                        });
                    }
                    navigate("./success", {replace: true}); //TODO redirect page
                }

                if (
                    subRequestError.code === "INVALID_MSISDN" ||
                    subRequestError.code === "GEN_ERR"
                ) {
                    setShowError(String(CONST_LABELS.get("LBL_ERR_INVALID_MSISDN")));
                    <div className="error-message">{showError}</div>;
                    return false;
                }
            });

        /* sendOtpHandler(
             // "optRequest,"
            purePhoneNumber.current,
           // String(CONST_LABELS.get("PHONE_LENGTH")),
           // httpGet('https://my-json-server.typicode.com/Advaith-K/MPLP-APL-response/JSON'
           reqId,
           resourceKey.subRequest
           ).then((response) => {
             console.log(res)
               if ("1" == CONST_CONF.get("PRINT_LOG")) console.log("sendOtpHandler STARTED, resCode is", res.resCode)
               regGtagOtpWithJson("OTPReqBtnClicked Click on Button", res, campaignIdFromParam);

               if (CONST_CONF.get("IS_TEST_ENV") === "1") {
                 res.code = "SUCCESS";
                 // setShowPin(true)
                 // return
               }

               if (res === null) {
                 regGtagOtpWithJson("Fail-Generic Error", res, campaignIdFromParam)
                 setShowError("Unable to process request, contact support");
                 <div className="error-message">{showError}</div>;

                 return false;
               }

               setPinUniqueId("");
               let jsonRes = res;


               if ("1" == CONST_CONF.get("PRINT_LOG")) console.log("Right before test env chenc", JSON.stringify(jsonRes))


               if ("1" == CONST_CONF.get("PRINT_LOG")) console.log("Right before resCode 3003 Check!!!", jsonRes.resCode);

               if ((jsonRes.code !== "SUCCESS") && (jsonRes.code !== "SUBSCRIPTION_ALREADY_EXIST")){
                 regGtagOtpWithJson("Fail-" + jsonRes.code, jsonRes, campaignIdFromParam)
               }

               if (jsonRes.code === "OTP_LIMIT_REACHED") {
                 setShowError("You have reached the OTP Limit. Please try again in 24 hours");
                 <div className="error-message"> {showError} </div>;
                 return false
               }

               if (jsonRes.code === "SUBSCRIPTION_ALREADY_EXIST") {

                 if ("1" == CONST_CONF.get("PRINT_LOG")) console.log("we should be redirecting here")

                 if (jsonRes.redirectUrl !== null) {
                   // window.location.replace(String(jsonRes.cgURL)) // OTP Page redirect, in case of antifraud
                   if ("1" == CONST_CONF.get("PRINT_LOG")) console.log("REDIRECTING TO SOMETHING")
                   navigate("./success", { replace: false, state: {id: jsonRes.redirectUrl}} );

                 }
                 navigate("./success", {replace: true});
               }


               if (jsonRes.code === "INVALID_MSISDN" || (jsonRes.code === "GEN_ERR")) {
                 setShowError(String(CONST_LABELS.get("LBL_ERR_INVALID_MSISDN")));
                 <div className="error-message">{showError}</div>;
                 return false;
               }

               if ("1" == CONST_CONF.get("PRINT_LOG")) console.log("Right before resCode 1 Check!!!", jsonRes.resCode);


               if (jsonRes.code === "SUCCESS") {
                 regGtagOtpWithJson("Success", jsonRes, campaignIdFromParam);

                 setProviderName(jsonRes.providerName)
                 setProviderType(jsonRes.providerType)

                 // setPinUniqueId(reqId.current);
                 // setPinUniqueId(jsonRes.resId);
                 if (jsonRes.allowSubConfirm === true) setShowPin(true);

                 if ("1" == CONST_CONF.get("PRINT_LOG")) console.log("setting showPin to true, display OTP page!")
               }



             }
             );
             //sub Request end
            };
            */
    }


    function replaceAt(index: number, replacement: string) {
        if (index >= phoneNumber.length) {
            return phoneNumber.valueOf();
        }

        return (
            phoneNumber.substring(0, index) +
            replacement +
            phoneNumber.substring(index + 1)
        );
    }

    const handlePinChange = (e: any) => {
        const result = e.target.value.replace(/\D/g, "");
        setPinEntered(result);
    };
    const handleInputChange = (e: any) => {
        const regex = /^(\+)[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value))
            setPhoneNumber(e.target.value.slice(4, 19)); //.replace(/\D/g, "");
    };

    const videoClickedHandler = (e: any) => {
        // setTimeout(()=> {setVideoClicked(true)}, 1200)
        e.preventDefault();
        setVideoClicked(true);
    };

    // const adjustedCountryCode = `+${Number(CONST_LABELS.get("COUNTRY_CODE"))}`;
    const adjustedCountryCode = `+${process.env.REACT_APP_COUNTRY_CODE}`;

    // useEffect(() => {}, []);
    console.log()
    return (
        <div>
            <div className="header">
                <div className="batelco-logo-wrapper">
                    <img className="batelco-logo" src={batelcoLogo}/>
                    {/*{batelcoLogo}*/}
                </div>
                <div className="icon">
                    <img src={bannerImg} alt="" onClick={videoClickedHandler}/>
                </div>
            </div>
            {/* <!-- registration section start --> */}
            {!videoClicked ? (
                <div className="click-img">

                    <div className="img-centering">
                        <img
                            width="auto"
                            height="auto"
                            className="video"
                            alt="help"
                            src={playerImg}
                            onClick={videoClickedHandler}
                        />
                        {/*<img*/}
                        {/*    width="auto"*/}
                        {/*    height="auto"*/}
                        {/*    className="video"*/}
                        {/*    alt="help"*/}
                        {/*    src={playerWideImg}*/}
                        {/*    onClick={videoClickedHandler}*/}
                        {/*/>*/}
                        <div className="svgcontainer">
                            {/*<img
                                className="svgplay"
                                src={playButton}
                                alt=""
                                onClick={videoClickedHandler}
                            />*/}

                        </div>
                    </div>
                    {/*<div className="watchnow-wrapper">*/}
                    {/*    <img className="watchnow" src={watchNow} alt=""/>*/}
                    {/*</div>*/}

                    <button
                        id="subscribe-btn"
                        disabled={loading}
                        //@ts-ignore
                        // eslint-disable-next-line no-restricted-globals
                        // onClick={evina_notify(e, function () {
                        //   onSubmitHandler();
                        // })}
                        onClick={videoClickedHandler}
                        className="btn btn--gradient shine"
                        style={{borderWidth: 0}}
                    >
                        {!loading ? (
                            !showPin ? (
                                <span className="text">
                    {CONST_LABELS.get("LBL_BTN_SUB")}
                  </span>
                            ) : (
                                <span className="text">
                    {CONST_LABELS.get("LBL_BTN_CONFIRM")}
                  </span>
                            )
                        ) : (
                            <span className="text">{CONST_LABELS.get("LBL_BTN_WAIT")}</span>
                        )}
                    </button>

                    <div className="footer-text-wrapper">
                        <p
                        className="footer-text"
                        style={{margin: "auto", alignContent: "center"}}
                        >
                        <br></br>
                    </p>
                    </div>
                </div>
            ) : (
                <div></div>
            )}
            {videoClicked ? (
                <div className="video-form">
                    {/*<div className="video-form-backdrop">*/}
                    {/*    <div className="gummy-bear-backdrop">*/}
                    {/*        <img src={gummyBearBackdrop}/>*/}
                    {/*    </div>*/}

                    {/*</div>*/}
                    <div className="registration" id="price">
                        <div className="section-block">
                            <div className="">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: process.env.REACT_APP_PRICEPOINT ?? 'missing from .env file',

                                    }}
                                />
                                <div className="section">
                                    <div className="banner"></div>
                                </div>
                            </div>
                        </div>
                        {!showCongrtas ? (
                            <div>
                                <div className="bottom-line"/>

                                <div className="input_container">
                                    {!showPin ? (
                                        <div>
                                            <p
                                                style={{
                                                    fontSize: 15,
                                                    fontWeight: "bold",
                                                    color: "white",
                                                }}
                                            >
                                                {process.env.REACT_APP_ENTER_MOBILE_LABEL ?? 'missing from .env'}
                                            </p>
                                            <input
                                                className={`${showError !== "" && `is-invalid`}`}
                                                type="text"
                                                inputMode="decimal"
                                                autoFocus={true}
                                                value={adjustedCountryCode + phoneNumber}
                                                maxLength={Number(CONST_LABELS.get("PHONE_LENGTH")) + 1}
                                                onFocus={() => setShowError("")}
                                                onChange={(e) => handleInputChange(e)}
                                                autoComplete="tel"
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <p
                                                style={{
                                                    fontSize: 15,
                                                    fontWeight: "bold",
                                                    color: "white",
                                                }}
                                            >
                                                {process.env.REACT_APP_ENTER_PIN_LABEL ?? 'missing from .env file'}
                                            </p>
                                            <input
                                                //   className="field required"
                                                className={`${showError && `is-invalid`}`}
                                                type="text"
                                                inputMode="decimal"
                                                onFocus={() => setShowError("")}
                                                autoFocus={true}
                                                value={pinEntered}
                                                maxLength={Number(CONST_LABELS.get("PIN_LENGTH"))}
                                                onChange={(e) => handlePinChange(e)}
                                                placeholder={process.env.REACT_APP_ENTER_PIN_LABEL ?? 'missing from .env file'}
                                                autoComplete="one-time-code"
                                            />
                                        </div>
                                    )}
                                    <div className="error-message">{showError}</div>
                                </div>
                                <button
                                    id="subscribe-btn"
                                    disabled={loading}
                                    //@ts-ignore
                                    // eslint-disable-next-line no-restricted-globals
                                    // onClick={evina_notify(e, function () {
                                    //   onSubmitHandler();
                                    // })}
                                    onClick={!showPin ? onSubmitHandler : onPinSubmitHandler}
                                    className="btn btn--gradient shine"
                                    style={{borderWidth: 0}}
                                >
                                    {!loading ? (
                                        !showPin ? (
                                            <span className="text">
                        {process.env.REACT_APP_SUB_BUTTON_LABEL ?? 'missing from .env'}
                      </span>
                                        ) : (
                                            <span className="text">
                        {process.env.REACT_APP_CONFIRM_BUTTON_LABEL ?? 'missing from .env'}
                      </span>
                                        )
                                    ) : (
                                        <span className="text">
                      {process.env.REACT_APP_WAIT_BUTTON_LABEL ?? 'missing from .env'}
                    </span>
                                    )}
                                </button>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: process.env.REACT_APP_PRICEPOINT ?? 'missing from .env file',
                                    }}
                                />
                                <div className="icon"></div>
                            </div>
                        ) : (
                            <div>
                                <img src={congrImg} alt=""/>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div></div>
            )}
            {!showPin ? (
                <div className="">
                    {/* </form> */}
                    <div className="info-text-wrapper">

                        <p className="footer-text">
                            {
                                //@ts-ignore
                            }

                            <div
                                dangerouslySetInnerHTML={{
                                    __html: process.env.REACT_APP_TC ?? 'missing from .env file',
                                }}
                            />
                            {/*<div className="batelco-slogan"><img src={batelcoSlogan}/></div>*/}

                            <br></br>
                        </p>
                    </div>
                </div>
            ) : (
                <div>
                    <div className="info-text-wrapper">
                    <p className="footer-text">
                        <div
                    dangerouslySetInnerHTML={{
                        __html: process.env.REACT_APP_TC ?? 'missing from .env file',
                    }}
                        />
                    </p>
                        </div>
                        </div>
            )}

        </div>
    );
};

export default HomePage;
